/**
 * 부가세 표기 배지 — 금액 표가 있는 화면 헤더 옆에 작게 표시.
 *
 *   - 기본 (별도): 영업/매입/매출분석/유지보수/비상벨/가격표
 *   - included=true (포함): 나라장터쇼핑몰 — 입찰 단가가 이미 VAT 포함
 */

interface Props {
  included?: boolean;
  className?: string;
}

export function VatNote({ included, className }: Props) {
  const text = included ? '※ 부가세 포함' : '※ 부가세 별도';
  const palette = included
    ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
    : 'bg-amber-50 text-amber-700 border-amber-200';
  return (
    <span
      className={`inline-block text-xs px-2 py-0.5 rounded border ${palette} ${className ?? ''}`}
      title={included ? '본 화면의 모든 금액은 부가세 포함입니다' : '본 화면의 모든 금액은 부가세 별도입니다'}
    >
      {text}
    </span>
  );
}
